import React, { useEffect, useState } from "react";
import CoverSection from "../components/CoverSection";
import Footer from "../components/Footer";
import InfoSection from "../components/InfoSection";
import {
  aboutObj,
  cliclaimObj,
  discoverObj,
  signupObj,
} from "../components/InfoSection/Data";
import Navbar from "../components/Navbar";
import Services from "../components/Services";
import Sidebar from "../components/Sidebar";
import FounderSection from "../components/FounderSection";
import AboutSection from "../components/AboutSection";
import { useTranslation } from "react-i18next";
import NosObjectifs from "../components/Objectifs";
import Faq from "../components/Faq";
import i18n from "../i18n";
import PartnersSection from "../components/PartnersSection";

// ✅ Same base URL used in QrLanding.js
const API_BASE = "https://api.cliclaim.com";

const Home = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [partners, setPartners] = useState([]);
  const { t } = useTranslation();

  const toggle = () => setIsOpen(!isOpen);

  useEffect(() => {
    // ✅ Fix 1: absolute URL to real API (not relative)
    // ✅ Fix 2: /getAll returns plain array (not paginated like /allCompanies)
    // ✅ Fix 3: filter only verified companies
    fetch(`${API_BASE}/company/getAll`)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then((data) => {
        const list = Array.isArray(data) ? data : [];
        const verified = list.filter(
          (c) => c.status === "verified" && c.company_name
        );
        setPartners(verified);
      })
      .catch((err) => {
        console.warn("Could not load partners:", err.message);
        setPartners([]);
      });
  }, []);

  const cliclaimObjWithTranslation = {
    ...cliclaimObj,
    topLine: t("cliclaim.topLine"),
    headline: t("cliclaim.headline"),
    description: t("cliclaim.description"),
    buttonLabel: t("cliclaim.buttonLabel"),
  };
  const aboutObjWithTranslation = {
    ...aboutObj,
    topLine: t("about.topLine"),
    headline: t("about.headline"),
    description: t("about.description"),
    buttonLabel: t("about.buttonLabel"),
  };
  const signupObjWithTranslation = {
    ...signupObj,
    topLine: t("signup.topLine"),
    headline: t("signup.headline"),
    description: t("signup.description"),
    buttonLabel: t("signup.buttonLabel"),
  };
  const discoverObjWithTranslation = {
    ...discoverObj,
    topLine: t("discover.topLine"),
    headline: t("discover.headline"),
    description: t("discover.description"),
    buttonLabel: t("discover.buttonLabel"),
  };

  const [isRTL, setIsRTL] = useState(i18n.language === "ar");

  useEffect(() => {
    const handleLanguageChange = (lng) => setIsRTL(lng === "ar");
    i18n.on("languageChanged", handleLanguageChange);
    return () => i18n.off("languageChanged", handleLanguageChange);
  }, []);

  return (
    <div className="page-wrapper">
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <CoverSection isRTL={isRTL} />
      <AboutSection {...cliclaimObjWithTranslation} isRTL={isRTL} />
      <InfoSection {...aboutObjWithTranslation} isRTL={isRTL} />
      <InfoSection {...discoverObjWithTranslation} isRTL={isRTL} />
      <InfoSection {...signupObjWithTranslation} isRTL={isRTL} />
      <Services isRTL={isRTL} />
      <NosObjectifs isRTL={isRTL} />
      <PartnersSection
  partners={partners}
  apiBase={API_BASE}
  isRTL={isRTL}
  title1={t("partners.title1")}
  title={t("partners.title")}
  subtitle={t("partners.subtitle")}
/>
      <Faq isRTL={isRTL} />
      <FounderSection isRTL={isRTL} />
      <Footer isRTL={isRTL} />
    </div>
  );
};

export default Home;
